import * as actionTypes from '../actions/actionTypes';

const initState = {
    //FEATURED VEHICLES STATE:
    loadingFeature: false,
    feauredVechils: null,
    errorFeauredVechils: null,
    //COMMING SOON : 
    commingSoon: false,
    //FEATURED DEALER STATE:
    loadingDealers: false,
    feauredDealers: null,
    errorDealers: null,
}

//######################################################################################### FEATURED VEHICLES :

const initGetFeaturedVehicles = (state, action) => {
    return {
        ...state,
        loadingFeature: action.loadingFeature,
        commingSoon: action.commingSoon,
    }
};

const getFeaturedVehicles = (state, action) => {
    return {
        ...state,
        feauredVechils: action.feauredVechils,
        loadingFeature: action.loadingFeature,
        commingSoon: action.commingSoon,
    }
};

const failGetFeaturedVehicles = (state, action) => {
    return {
        ...state,
        errorFeauredVechils: action.errorFeaturedVehicls,
        commingSoon: action.commingSoon,
    }
};

//********************#################################**************FEATURED DEALERS :

const initGetFeaturedDealers = (state, action) => {
    return {
        ...state,
        loadingDealers: action.loadingDealers
    }
};

const getFeaturedDealers = (state, action) => {
    return {
        ...state,
        feauredDealers: action.feauredDealers,
        loadingDealers: action.loadingDealers,
    }
};

const failGetFeaturedDealers = (state, action) => {
    return {
        ...state,
        errorDealers: action.errorDealers,
    }
};

const commingSoon = (state, action) => {
    return {
        ...state,
        commingSoon: action.commingSoon,
    }
};


const reducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.INIT_GET_FEATURED_VEHICLS: return initGetFeaturedVehicles(state, action)
        case actionTypes.GET_FEATURED_VEHICELS: return getFeaturedVehicles(state, action)
        case actionTypes.Fail_GET_FEATURED_VEHILELS: return failGetFeaturedVehicles(state, action)
        case actionTypes.INIT_GET_FEATURED_DEALERS: return initGetFeaturedDealers(state, action)
        case actionTypes.GET_FEATURED_DEALERS: return getFeaturedDealers(state, action)
        case actionTypes.Fail_GET_FEATURED_DEALERS: return failGetFeaturedDealers(state, action)
        case actionTypes.COMMING_SOON: return commingSoon(state, action)
        default: return state;
    }
};

export default reducer;